import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";
import Logo from "../assets/img/logo-mark.svg";
import GhanaFlag from "../assets/img/ghanaflag.jpg";
import PatternedBackground from "../components/PatternedBG1";
import { ReactComponent as CloseIcon } from "../assets/UiElements/WebCloseIcons.svg";

export const AuthLayout = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isLoginRoute = location.pathname === "/onboard/login";

  return (
    <div style={{ minHeight: "100vh" }}>
      {/* Top header with contact info - Fixed */}
      <div className="top-contact-header" role="banner" aria-label="Contact header">
        <span className="contact-full">To speak to a financial adviser, call us:</span>
        <span className="contact-short">To speak to a financial adviser, call us:</span>
        <span className="contact-number">0860 66 66 59</span>
      </div>
      
      <nav
        className="navbar navbar-expand-lg navbar-light bg-light shadow"
        style={{
          height: "70px",
          zIndex: 999,
          position: "fixed",
          top: "42px", // Height of the contact header
          left: 0,
          right: 0,
          width: "100%",
          padding: "0 15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Left section: Logo, close button and Self Service Portal text */}
        <div
          className="d-flex align-items-center gap-3"
          style={{ justifyContent: "flex-start", flexGrow: 1 }}
        >
          <img
            src={Logo}
            alt="om logo"
            style={{ height: "90px", marginLeft: "0" }}
          />
          
          {!isLoginRoute && (
            <>
              {/* Close button */}
              <button
                onClick={() => navigate("/onboard/login")}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  marginLeft: "8px",
                }}
                aria-label="Close and return to login"
              >
                <CloseIcon width={24} height={24} />
              </button>
            </>
          )}
          
          {/* Self Service Portal text - shown on both desktop and mobile */}
          <p
            className="lead fw-bold mb-0 show-desktop show-mobile ssp-mobile"
            style={{
              fontSize: "1.25rem",
              color: "#333",
              marginLeft: !isLoginRoute ? "8px" : "0px"
            }}
          >
            Self Service Portal
          </p>
        </div>

        {/* Right section: Ghana button and dynamic Login/Create Account button */}
        <div className="d-flex align-items-center gap-3">
          {/* Ghana button with flag */}
          <button
            className="ghana-flag-btn"
            style={{
              background: "none",
              border: "1px solid #ddd",
              borderRadius: "20px",
              padding: "8px 12px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "14px",
              fontWeight: "500",
              color: "#333",
            }}
            aria-label="Ghana"
          >
            <img
              src={GhanaFlag}
              alt="Ghana flag"
              style={{
                width: "20px",
                height: "20px",
                clipPath: "polygon(50% 0%, 90% 25%, 90% 75%, 50% 100%, 10% 75%, 10% 25%)",
                objectFit: "cover",
              }}
            />
            <span className="country-label">Ghana</span>
          </button>
          
          {/* Dynamic Login/Create Account button */}
          <button
            onClick={() => navigate(isLoginRoute ? "/onboard/verify-ghana-card" : "/onboard/login")}
            style={{
              background: "#38a169",
              color: "white",
              border: "none",
              borderRadius: "20px",
              padding: "8px 16px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
            aria-label={isLoginRoute ? "Go to create account" : "Go to login"}
          >
            {!isLoginRoute && <LockOutlined style={{ fontSize: "14px" }} />}
            {isLoginRoute ? "Create Account" : "Login"}
          </button>
        </div>
      </nav>

      {/* Scrollable content area with patterned background */}
      <PatternedBackground 
        style={{ 
          minHeight: "100vh",
          paddingTop: "112px", // Space for both fixed headers (42px + 70px)
          position: "relative",
          zIndex: 1,
        }}
      >
        <section style={{ paddingTop: "2%", zIndex: 2, position: "relative" }}>
          {props.children}
        </section>
      </PatternedBackground>

      {/* Mobile responsiveness */}
      <style>
        {`
          .show-desktop { display: block; }
          .show-mobile { display: none; }

          /* Top contact header - responsive */
          .top-contact-header {
            background-color: #000;
            color: #fff;
            text-align: center;
            padding: 8px 15px;
            font-size: 14px;
            font-weight: 400;
            z-index: 1000;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            box-sizing: border-box;
          }
          .top-contact-header .contact-full { display: inline; }
          .top-contact-header .contact-short { display: none; }
          .top-contact-header .contact-number { color: #B9E2B6; font-weight: 500; margin-left: 6px; }

          @media (max-width: 768px) {
            .top-contact-header { font-size: 13px; padding: 6px 12px; }
            .top-contact-header .contact-full { display: none; }
            .top-contact-header .contact-short { display: inline; }
            .top-contact-header .contact-number { font-size: 13px; margin-left: 6px; }
            /* adjust navbar to sit below reduced header */
            .ssp-mobile { font-size: 0.9rem; }
            .navbar { top: 40px !important; }
          }

          @media (max-width: 400px) {
            .top-contact-header { font-size: 12px; padding: 6px 8px; }
            .top-contact-header .contact-number { font-size: 12px; }
            .navbar { top: 36px !important; }
            .ssp-mobile { font-size: 0.7rem; }
          }
          @media (max-width: 768px) {
            .show-desktop { display: none !important; }
            .show-mobile { display: block !important; }
            .ssp-mobile { font-size: 1rem; margin-left: 2px !important; }
            .navbar {
              flex-direction: row;
              height: auto;
              padding: 8px 4px !important;
              justify-content: space-between;
              flex-wrap: wrap;
              align-items: flex-start !important;
            }
            .navbar img {
              height: 40px;
              margin-left: 0 !important;
              margin-top: -14px !important;
            }
            .navbar button {
              margin-top: 0;
            }
            
            /* Remove gap on left section on mobile */
            .d-flex.align-items-center.gap-3:first-child {
              gap: 4px !important;
              padding-left: 0 !important;
              align-items: flex-start !important;
            }
            
            /* Adjust button spacing on mobile */
            .d-flex.align-items-center.gap-3:last-child {
              gap: 4px !important;
            }
            
            .mobile-header-nav {
              font-size: 0.9rem;
              text-align: center;
            }
          }

          @media (max-width: 576px) {
            /* Make top header text smaller on mobile */
            div[style*="backgroundColor: #000"] {
              font-size: 12px !important;
              padding: 6px 10px !important;
            }
            
            /* Hide country label text on small screens, keep flag only */
            .country-label { display: none; }
            
            /* Hide Ghana flag button completely on mobile */
            .ghana-flag-btn { display: none !important; }

            .navbar {
              padding: 6px 2px !important;
            }
            
            /* Make buttons smaller on very small screens */
            .d-flex.align-items-center.gap-3:last-child button {
              padding: 6px 10px;
              font-size: 12px;
            }
            
            .d-flex.align-items-center.gap-3:last-child img {
              width: 16px;
              height: 16px;
              clipPath: polygon(50% 0%, 90% 25%, 90% 75%, 50% 100%, 10% 75%, 10% 25%);
            }

            /* Stack navigation buttons if needed */
            .d-flex.align-items-center.gap-3:first-child {
              gap: 8px;
            }
          }
        `}
      </style>
    </div>
  );
};
